import { SwipeableDrawer, Box, Typography, Divider } from "@mui/material";
import metricOneIcon from "../../assets/metric_1.svg";
import metricTwoIcon from "../../assets/metric_2.svg";
import metricThreeIcon from "../../assets/metric_3.svg";
import CohortDrawerContent from "../CohortDrawerContent/CohortDrawerContent";
import CohortAudioPlayer from "../CohortAudioPlayer/CohortAudioPlayer";
import { useCohortAudioPlayer } from "../../utils/useCohortAudioPlayer";
import AnimatedGifText from "../AnimatedGifText/AnimatedGifText";
import useTranslationSetup from "../../utils/useTranslationSetup";
import "./CohortBottomDrawer.css";

const COHORT_METRIC_ICONS = [metricOneIcon, metricTwoIcon, metricThreeIcon];

const CohortBottomDrawer = ({
  open,
  onClose,
  image,
  title,
  gifText,
  gifTextArray,
  cohort,
}) => {
  const { tSubject } = useTranslationSetup();
  const [isPlaying, playAudio, stopAudio, audioRef] = useCohortAudioPlayer(
    cohort?.audio
  );

  return (
    <SwipeableDrawer
      anchor="bottom"
      open={open}
      onClose={onClose}
      onOpen={() => {}}
      disableSwipeToOpen
      PaperProps={{
        sx: {
          maxHeight: "90vh",
          overflow: "hidden",
          zIndex: 1,
        },
      }}
    >
      <Box>
        <Box className="cohort-drawer-puller" />
        <Box
          className={`cohort-drawer-bg-color ${cohort?.className}-drawer-bg-color`}
        >
          <Box
            className={`cohort-drawer-oval-color ${cohort?.className}-oval-color`}
          >
            <Typography className="cohort-drawer-title">{title}</Typography>
            <Box
              component="img"
              src={image}
              alt={title}
              className="cohort-drawer-image"
            />
          </Box>
          <Box className="cohort-drawer-media">
            <CohortAudioPlayer
              isPlaying={isPlaying}
              playAudio={playAudio}
              stopAudio={stopAudio}
              audioRef={audioRef}
              buttonStyle={{
                backgroundColor: "#A2C357",
                minWidth: 0,
                padding: "6px",
                borderRadius: "32px",
              }}
              iconStyle={{ color: "#FFFFFF", width: "20px", height: "20px" }}
            />
            {gifTextArray && (
              <AnimatedGifText
                textArray={cohort.gifTextArray}
                pauseDuration={cohort.pauseDuration || 150}
                speed={cohort.gifSpeed}
              />
            )}
          </Box>
          <Box>
            {(cohort?.descriptionKey || gifText) && (
              <Typography className="cohort-drawer-gif-text">
                {cohort?.descriptionKey
                  ? tSubject(cohort.descriptionKey)
                  : gifText}
              </Typography>
            )}
          </Box>
        </Box>
        <Box className="cohort-drawer-metrics-wrapper">
          <Box className="cohort-drawer-metric-icons">
            {COHORT_METRIC_ICONS.map((icon, index) => (
              <img
                key={index}
                src={icon}
                alt=""
                aria-hidden="true"
                className="cohort-drawer-metric-icon"
              />
            ))}
          </Box>
          <Typography className="cohort-drawer-metric-description">
            {tSubject("cohort_metrics_description")}
          </Typography>
        </Box>
        <Divider className="cohort-drawer-divider" />
        <CohortDrawerContent
          contentKey={cohort?.contentKey}
          content={cohort?.content}
        />
      </Box>
    </SwipeableDrawer>
  );
};

export default CohortBottomDrawer;
